<template>
  <div class="back-and-forth" ref="backAndForthRef">
    <hr class="shape-left" />
    <hr class="shape-right" />
    <slot />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { createHeightMeasurer } from '@/utils/heightMeasurer'

const backAndForthRef = ref(null)
const { measureElementHeight, setupObservers, cleanup } = createHeightMeasurer()

const measureHeights = () => {
  measureElementHeight(backAndForthRef, '.intro-wrapper', '--intro-height')
}

onMounted(() => {
  nextTick(() => {
    measureHeights();
  });
  document.fonts?.ready.then(measureHeights);
  window.addEventListener('resize', measureHeights);
  //setupObservers(backAndForthRef, measureHeights)
})

onUnmounted(() => {
  cleanup(measureHeights)
})
</script>

<style scoped>
@import '@/css/breakpoints.css';

hr {
  display: none;
}

.back-and-forth {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.back-and-forth:nth-child(odd) {
  --left-polygon: polygon(0 30%, 30% 100%, 0 100%);
  --right-polygon: polygon( 40% 0%, 100% 0%, 100% 100%, 80% 100%);
}

.back-and-forth:nth-child(even) {
  --left-polygon: polygon(0 0, 0 100%, 00% 100%, 50% 0%);
  --right-polygon: polygon(70% 100%, 100% 0%, 100% 100%);
}

@media (--wide) {
.back-and-forth:nth-child(odd) :deep(.textblock) {
  margin-left: clamp(5%, 20%, 200px);
  margin-right: auto;
  text-align: left;
}

  .back-and-forth:nth-child(even) :deep(.textblock) {
    margin-left: auto;
    margin-right: clamp(5%, 20%, 200px);
    text-align: right;
  }
}

  .back-and-forth:nth-child(even) :deep(.intro-wrapper) {
    text-align: right;
  }


@media (--wide) {

.back-and-forth:nth-child(odd) :deep(figure:not(.align-l):not(.align-c):not(.align-r)) {
  margin-left: clamp(3%, 14%, 140px);
  margin-right: auto;
}
}

.back-and-forth:nth-child(even) :deep(figure:not(.align-l):not(.align-c):not(.align-r)) {
  margin-left: auto;
  margin-right: clamp(3%, 14%, 140px);
}


.back-and-forth:nth-child(even) :deep(figure:not(.align-l):not(.align-c):not(.align-r) figcaption) {
  text-align: right;
}

/* Contact/Image-Text block alternation */
.back-and-forth:nth-child(odd) :deep(.contact) {
  flex-direction: row; /* Image left, content right */
}

.back-and-forth:nth-child(even) :deep(.contact) {
  flex-direction: row-reverse; /* Content left, image right */
  text-align: right;
}

@media (--narrow) {
  div {
    padding-inline: 2rem;
  }
}

@media (--wide) {
  hr {
    display: block;
  }

  hr.shape-left,
  hr.shape-right {
    border: none;
    margin: 0;
    background-color: transparent;
    height: calc(var(--intro-height) + 1rem);
    width: 50%;
  }

  .shape-left {
    float: left;
    clip-path: var(--left-polygon);
    shape-outside: var(--left-polygon);
  }

  .shape-right {
    float: right;
    clip-path: var(--right-polygon);
    shape-outside: var(--right-polygon);
  }

}


</style>
